<template>
  <div id="page-tips-pint-sale" class="d-flex">
    <MainBarMenuV2 />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">

      <template v-if="getProcessing">
        <div class="page-tips-shift py-3">
          <loader-dots-v2 />
        </div>
      </template>

      <template v-else>
        <b-container>
          <b-row>
            <b-col cols="12">
              <h2 class="mb-2 mt-3">
                <b>Solicitudes para habilitar reportes de turnos </b>
              </h2>
            </b-col>

            <template v-if="getBlocks.data.length < 1">
             <b-col cols="12" sm="8" class="mb-4 mt-4">
               <alert-v2
                   type="informative"
                   show
                   include-img>
                 <template #body>
                   <p class="text-formatting-v2">
                     <strong class="h4-v2">¡En hora buena! 🎉</strong>
                     <br>
                     <strong class="h5-v2">
                       No tienes solicitudes pendientes de managers para habilitar reportes de turnos.
                     </strong>
                   </p>
                 </template>
                 <template #img>
                   <img
                       src="@/assets/modules/propinas/img/master.svg"
                       alt="master"
                       height="363px"
                       width="363px" />
                 </template>
               </alert-v2>
             </b-col>
            </template>
            <template v-else>
              <!-- Filtros -->
              <b-col cols="12">
                <b-container>
                  <b-row class="pt-5 pb-5">
                    <b-col>
                      <button
                          id="popover-calendar"
                          class="button-v2 primary">
                        <div class="m-1 d-flex align-items-center justify-content-between">
                          <img class="centerImg1 arrow" src="@/assets/modules/propinas/icon/filter-line-white.svg" width="15px" alt="">
                          <p class="m-0 pl-3 text-formatting-v2">
                            Filtrar por orden de fecha
                          </p>

                        </div>
                      </button>
                    </b-col>
                    <b-col>
                      <button
                          @click.prevent="changeEnableFilter"
                          class="button-v2 outline-light">
                        Filtrar por habilitado
                        <img
                            :style="isEnableFiler ? null : 'opacity: 0.5'"
                            class="ml-2"
                            src="@/assets/modules/propinas/icon/radio-button-fill.svg"
                            alt="check-warning" />
                      </button>
                    </b-col>
                    <b-col>
                      <button
                          @click.prevent="changeDisabledFiler"
                          class="button-v2 outline-light">
                        Filtrar por habilitar
                        <img
                            :style="isDisabledFiler ? null : 'opacity: 0.5'"
                            class="ml-2"
                            src="@/assets/modules/propinas/icon/radio-button-fill.svg"
                            alt="check-warning" />
                      </button>
                    </b-col>
                  </b-row>
                </b-container>

                <!-- Filtro -->
                <b-popover
                    id="popover"
                    target="popover-calendar"
                    triggers="hover focus"
                    placement="auto"
                    class="p-3">

                  <div>
                    <div class="row d-flex justify-content-between mt-2 center-div">
                      <div class="col-12 ">
                        <b-form-datepicker
                            v-model="dateToFilter"
                            :date-format-options="{
                          year: 'numeric',
                          month: 'short',
                          day: '2-digit',
                          weekday: 'short'
                      }"
                            :max="get_today"
                            @input="applyFiltersToQuery"
                            size="lg"
                            placeholder="Seleccione una fecha"
                            locale="es-CO" />
                      </div>
                    </div>
                  </div>
                </b-popover>
              </b-col>
              <!-- end -->
              <b-col
                  v-for="(block, blockKey) in getBlocks.data"
                  :key="blockKey"
                  cols="12"
                  class="mb-4 mt-4">
               <shift-report
                   :manager-name="block.manager_name ? block.manager_name : 'null' "
                   :block-id="block.block_id"
                   :is-blocked="block.is_blocked"
                   :path-image="block.image"
                   :point-sale="block.point_sale"
                   :reason-blocked="block.reason"
                   :blocked-date="block.blocked_date"
                   :index="blockKey"/>
              </b-col>
              <b-col class="center-div">
                <paginator
                    :data="getBlocks"
                    :limit="1"
                    @pagination-change-page="paginate"
                ></paginator>
              </b-col>
            </template>

          </b-row>
        </b-container>
      </template>
    </div>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters
} from "vuex"

export default {
  name: "enableShiftReports",

  data: () => ({
    dateToFilter: '',
    isEnableFiler: false,
    isDisabledFiler: false,
  }),

  components: {
    MainBarMenuV2: () => import("@/components/layouts/MainBarMenuV2"),
    HeadingUser: () => import("@/components/user/HeadingUser"),
    alertV2: () => import('@/components/common/toasters/AlertV2.vue'),
    shiftReport: () => import('@/components/Propinas/Cards/ShiftReport.vue'),
    paginator: () => import('laravel-vue-pagination')
  },

  computed: {
    ...mapGetters('modShiftReport', [
        'getProcessing',
        'getBlocks'
    ])
  },

  beforeMount() {
    this.getManagerBlock()
  },

  methods: {
    ...mapActions('modShiftReport', [
        'getManagerBlock',
    ]),

    paginate (page = 1) {
      this.getManagerBlock(this.validData(page))
    },

    changeEnableFilter () {
      this.isEnableFiler = !this.isEnableFiler
      this.applyFiltersToQuery()
    },

    changeDisabledFiler () {
      this.isDisabledFiler = ! this.isDisabledFiler
      this.applyFiltersToQuery()
    },

    applyFiltersToQuery() {
      this.getManagerBlock(this.validData())
    },

    validData (page = 1) {
      let data = { page }
      if (this.dateToFilter !== '') { data.date = this.dateToFilter }
      if (this.isEnableFiler) {
        this.isDisabledFiler = false
        data.enables = this.isEnableFiler
      }
      if (this.isDisabledFiler) {
        this.isEnableFiler = false
        data.disables = this.isDisabledFiler
      }
      return data
    }
  }

}
</script>

<style scoped>

</style>